import React from 'react';
import { render } from 'react-dom';
import store, { history } from './store/configureStore';
import Root from './components/Root';
import * as serviceWorker from './serviceWorker';
import {
    message,
  } from 'antd';
import Axios from 'axios';
import { logout, logoutNoXhr } from 'reducers/settingsReducer/settingsReducer';

Axios.interceptors.response.use(response => {
    return response
  }, error => {
    return new Promise((resolve, reject) => {
        if (!error.response) {
            message.error('Kesalahan jaringan');
            store.dispatch(logoutNoXhr());
        } else {
            if (error.response.status === 401) {
                message.error('Token sudah expired, silahkan login kembali');
                store.dispatch(logoutNoXhr());
            } else {
                reject(error);
            }
        }
    });
});

render(<Root store={store} history={history} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
